"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Modal.css");
var icons_1 = require("@tiendanube/icons");
var __1 = require("..");
var BaseModal_1 = __importDefault(require("./BaseModal"));
function Modal(_a) {
    var title = _a.title, show = _a.show, onDismiss = _a.onDismiss, children = _a.children, primaryAction = _a.primaryAction, secondaryAction = _a.secondaryAction, _b = _a.portal, portal = _b === void 0 ? true : _b;
    var memorizedDismissable = React.useMemo(function () {
        return onDismiss && (React.createElement("button", { type: "button", "aria-label": "Close", className: "nimbus--modal-header__close", onClick: onDismiss },
            React.createElement(icons_1.CloseIcon, null)));
    }, [onDismiss]);
    var memorizedSecondary = secondaryAction && (React.createElement("div", { className: "nimbus--action-wrapper__item" },
        React.createElement(__1.Button, { onClick: secondaryAction.onClick }, secondaryAction.children)));
    var memorizedPrimary = primaryAction && (React.createElement("div", { className: "nimbus--action-wrapper__item" },
        React.createElement(__1.Button, { onClick: primaryAction.onClick, appearance: primaryAction.appearance, icon: primaryAction.icon, iconPosition: primaryAction.iconPosition, disabled: primaryAction.disabled }, primaryAction.children)));
    return (React.createElement(BaseModal_1.default, { show: show, onDismiss: onDismiss, portal: portal },
        React.createElement("div", { className: "nimbus--modal-header" },
            React.createElement("div", { className: "nimbus--modal-header__title" },
                React.createElement(__1.Title, { type: "h4" }, title)),
            memorizedDismissable),
        React.createElement("div", { className: "nimbus--modal-body" }, children),
        (memorizedSecondary || memorizedPrimary) && (React.createElement("div", { className: "nimbus--modal-footer" },
            React.createElement("div", { className: "nimbus--action-wrapper" },
                memorizedSecondary,
                memorizedPrimary)))));
}
exports.default = Modal;
//# sourceMappingURL=Modal.js.map